import React from 'react'
import { Box, Typography } from '@creditas-ui/react'
import { ModalBanner } from 'shared/ui/ModalBanner/ModalBanner'
import { NotificationIds } from 'notifications/domain/NotificationsIds'
import image from './images/portal-upload-documents.png'
import * as S from './HomeRefinancingDocuments.styles'

const HomeRefinancingDocuments = ({ isOpen, closeModal }) => {
  return (
    <ModalBanner
      isOpen={isOpen.documents}
      closeModal={() => closeModal(NotificationIds.HomeRefinancingDocuments)}
      title="Chegou mais uma novidade 📬"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        height="100%"
      >
        <Box width="50%">
          <S.ContainerImage>
            <S.Image
              src={image}
              alt="imagem envie os documentos do cliente para agilizar a aprovação"
            />
          </S.ContainerImage>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          width="50%"
          pr="49px"
          pt="47px"
        >
          <Box
            bg="neutral.0"
            borderRadius="16px"
            width="159px"
            textAlign="center"
          >
            <Typography
              color="neutral.80"
              variant="bodyXsRegular"
              p="3px 8px 3px 8px"
            >
              Home Equity
            </Typography>
          </Box>
          <Typography variant="bodyLgRegular" pt="24px" color="neutral.100">
            Agora você pode enviar os documentos do cliente através do portal!
          </Typography>
          <Typography
            variant="bodySmLight"
            pt="16px"
            pb="40px"
            color="neutral.90"
          >
            Faça o upload dos arquivos após a criação da proposta e agilize o
            andamento da análise.
          </Typography>
        </Box>
      </Box>
    </ModalBanner>
  )
}

export { HomeRefinancingDocuments }
